import { MUTATION_KEYS, removeProductFromCartProducer } from '@rc-d2c/context-manager';
import { useMutation, useMutationState } from '@tanstack/react-query';

export function useRemoveProductFromCartMutation(skuId: string) {
  return useMutation({
    mutationKey: MUTATION_KEYS.REMOVE_PRODUCT_FROM_CART(skuId),
    mutationFn: () => {
      return removeProductFromCartProducer(skuId);
    },
  });
}

export function useRemoveProductFromCartMutationState(skuId?: string) {
  return useMutationState({
    filters: { mutationKey: MUTATION_KEYS.REMOVE_PRODUCT_FROM_CART(skuId) },
    select: (mutation) => ({ ...mutation.state, skuId: mutation.options.mutationKey?.[1] as string }),
  });
}
